function myFunction() {
  var dots = document.getElementById("dots");
  var moreText = document.getElementById("more");
  var aText = document.getElementById("myLink");

  if (dots.style.display === "none") {
    dots.style.display = "inline";
    aText.innerHTML = "Read more"; 
    moreText.style.display = "none";
  } else {
    dots.style.display = "none";
    aText.innerHTML = "Read less"; 
    moreText.style.display = "inline";
  }
}

function myFunction_2() {
  var dots_2 = document.getElementById("dots_2");
  var moreText_2 = document.getElementById("more_2");
  var aText_2 = document.getElementById("myLink_2");
  
  if (dots_2.style.display === "none") {
    dots_2.style.display = "inline";
    aText_2.innerHTML = "Read more"; 
    moreText_2.style.display = "none";
  } else {
    dots_2.style.display = "none";
    aText_2.innerHTML = "Read less"; 
    moreText_2.style.display = "inline";
  }
}

function myFunction_3() {
  var dots_3 = document.getElementById("dots_3");
  var moreText_3 = document.getElementById("more_3");
  var aText_3 = document.getElementById("myLink_3");
  
  if (dots_3.style.display === "none") {
    dots_3.style.display = "inline";
    aText_3.innerHTML = "Read more"; 
    moreText_3.style.display = "none";
  } else {
    dots_3.style.display = "none";
    aText_3.innerHTML = "Read less"; 
    moreText_3.style.display = "inline";
  }
}

function myFunction_4() {
  var dots_4 = document.getElementById("dots_4");
  var moreText_4 = document.getElementById("more_4");
  var aText_4 = document.getElementById("myLink_4");
  
  if (dots_4.style.display === "none") {
    dots_4.style.display = "inline";
    aText_4.innerHTML = "Read more"; 
    moreText_4.style.display = "none";
  } else {
    dots_4.style.display = "none";
    aText_4.innerHTML = "Read less"; 
    moreText_4.style.display = "inline";
  }
}

function myFunction_5() {
  var dots_5 = document.getElementById("dots_5");
  var moreText_5 = document.getElementById("more_5");
  var aText_5 = document.getElementById("myLink_5");
  
  if (dots_5.style.display === "none") {
    dots_5.style.display = "inline";
    aText_5.innerHTML = "Read more"; 
    moreText_5.style.display = "none";
  } else {
    dots_5.style.display = "none";
    aText_5.innerHTML = "Read less"; 
    moreText_5.style.display = "inline";
  }
}

function myFunction_6() {
  var dots_6 = document.getElementById("dots_6");
  var moreText_6 = document.getElementById("more_6");
  var aText_6 = document.getElementById("myLink_6");
  
  if (dots_6.style.display === "none") {
    dots_6.style.display = "inline";
    aText_6.innerHTML = "Read more"; 
    moreText_6.style.display = "none";
  } else {
    dots_6.style.display = "none";
    aText_6.innerHTML = "Read less"; 
    moreText_6.style.display = "inline";
  }
}

function myFunction_7() {
  var dots_7 = document.getElementById("dots_7");
  var moreText_7 = document.getElementById("more_7");
  var aText_7 = document.getElementById("myLink_7");
  
  if (dots_7.style.display === "none") {
    dots_7.style.display = "inline";
    aText_7.innerHTML = "Read more"; 
    moreText_7.style.display = "none";
  } else {
    dots_7.style.display = "none";
    aText_7.innerHTML = "Read less"; 
    moreText_7.style.display = "inline";
  }
}